
define('text!TescoMobile_Esim/template/minicart/esim-device.html',[],function () { return '<!-- ko if: $parent.tm_options.extension_attributes.is_esim_device --><div class="esim"><span class="label"><!-- ko i18n: \'eSIM\' --><!-- /ko --></span> <span class="value"><!-- ko i18n: \'Your phone comes with an eSIM\' --><!-- /ko --></span></div><!-- /ko -->';});

